//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectSnippet from "~/components/objects/ObjectSnippet";

const PER_PAGE = 12
export default {
  name: 'Objects',
  components: { ObjectSnippet },
  layout: 'public_new',
  async asyncData({ params, store, query, error }) {

    const page = 0
    const objects = await store.dispatch('objects/publicObjects', {
      ...query,
      with_events: true,
      limit: PER_PAGE,
      offset: page * PER_PAGE,
      order: '-total_score',
    })
      .then(response => response.items)

    return {
      categories: await store.dispatch('categories/getNavTree'),
      objects: objects,
    }
  },
  data() {
    return {
      page: 0,
      objects: [],
      categories: [],
      currentCategory: {},
      per_page: PER_PAGE,
    }
  },
  head() {
    return {
      title: 'ViStat.Org - Интерактивная инфографика, схемы, иллюстрации. Искусство, техника, космос, оружие, архитектура.'
    }
  },
  computed: {},
  methods: {
    infiniteScroll($state) {
      this.page++;

      this.$store.dispatch('objects/publicObjects', {
        ...this.$route.query,
        with_events: true,
        limit: PER_PAGE,
        offset: this.page * PER_PAGE,
        order: '-total_score',
      })
        .then(response => {
          if (response.items.length) {
            this.objects.push(...response.items)

            $state.loaded()
          } else {
            $state.complete()
          }
        })
    }
  }
}
